module.exports = __webpack_public_path__ + "static/media/mobile_app_iphonex.8000f9ec.png";